/**
 * LocalStorage access that cannot throw. A kiosk tablet may have storage
 * disabled or full; persistence is a convenience here, never a requirement.
 */
const storage = (): Storage | null => {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    // Safari in private mode throws on property access.
    return null;
  }
};

export const readStoredJson = (key: string): unknown => {
  const store = storage();
  if (store === null) return null;
  try {
    const raw = store.getItem(key);
    return raw === null ? null : (JSON.parse(raw) as unknown);
  } catch {
    // Unreadable or corrupt entry — treated as absent.
    return null;
  }
};

export const writeStoredJson = (key: string, value: unknown): void => {
  const store = storage();
  if (store === null) return;
  try {
    store.setItem(key, JSON.stringify(value));
  } catch {
    // Quota exceeded — the in-memory state stays authoritative.
  }
};

export const removeStoredKey = (key: string): void => {
  const store = storage();
  if (store === null) return;
  try {
    store.removeItem(key);
  } catch {
    // Nothing useful to do.
  }
};
